const decorateSplitGroupsWithTotalCount = (groups, totalCount) => {
  if (groups.length === 0) {
    return groups;
  }
  const nextGroups = groups.map((group) => {
    return {
      ...group,
      groupTotalCount: group.resources.length
    };
  });
  const totalLoaded = nextGroups.reduce((acc, group) => acc + group.groupTotalCount, 0);
  nextGroups[nextGroups.length - 1].groupTotalCount += totalCount - totalLoaded;
  return nextGroups;
};

export { decorateSplitGroupsWithTotalCount };
//# sourceMappingURL=decorateGroupsWithTotalCount.js.map
